import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/job-titles',
    name: 'job-title',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/job-title')
  }
]
